import styled from 'styled-components';
import { Button } from 'antd';
import { Close } from '@styled-icons/material-rounded/Close';

export const ContainerOverlay = styled.div`
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: ${(props) => props.theme.colors.overlay};

  animation: opacity 0.25s ease-in-out;

  @keyframes opacity {
    0% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  &.closeAnimation {
    animation: opacityClose 0.25s ease-in-out;

    @keyframes opacityClose {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
`;

export const SideLeafContainer = styled.div`
  background-color: ${(props) => props.theme.colors.gray2};
  height: 100%;
  width: 71%;
  max-width: 26.125rem;
  top: 0;
  position: fixed;
  padding: 1rem 0.5rem;

  display: inline-block;
  overflow: auto;
  box-shadow: ${({ theme }) => theme.commoms.boxShadow2};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 2rem 1.5rem;
  }

  &.from-left {
    left: 0;
    animation: fromLeft 0.25s ease-in;

    @keyframes fromLeft {
      0% {
        transform: translateX(-25rem);
      }
      100% {
        transform: translateX(0);
      }
    }

    &.closeAnimation {
      animation: backToLeft 0.25s ease-out;

      @keyframes backToLeft {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-25rem);
        }
      }
    }
  }

  &.from-right {
    right: 0;
    animation: fromRight 0.25s ease-in;

    @keyframes fromRight {
      0% {
        transform: translateX(25rem);
      }
      100% {
        transform: translateX(0);
      }
    }

    &.closeAnimation {
      animation: backToRight 0.25s ease-out;

      @keyframes backToRight {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(25rem);
        }
      }
    }
  }
`;

export const SideLeafHeader = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  padding-right: 0.5rem;
`;

export const CloseSideLeafButton = styled(Button)`
  background: unset;
  border: unset;
  padding: unset;
  outline: unset;
  margin-left: auto;

  &:hover {
    background: unset;
  }
`;

export const CloseIcon = styled(Close)`
  width: 1.25rem;
  color: ${({ theme }) => theme.colors.grayDark2};
`;
